export class ClinicRabiesCodeModel {
    link_no: number
    link_type: number
    code_name: string 

    constructor(
        link_no: number,
        link_type: number,
        code_name: string, 
    ) {
        this.link_no = link_no
        this.link_type = link_type
        this.code_name = code_name 
    }
}